import LicitacionesItem from "../components/Dashboard/LicitacionesPublicas/LicitacionesItemCard.tsx"
import AdjudicatedItem from "../components/Dashboard/PublicProjectsAdjudicated/AdjudicadosItemCard.tsx"
import QuotationsList from "../components/MarketPlace/QuotationsList"
import AllProjectsItem from "../components/Dashboard/AllProjectsItem/AllProjectsItemCard.tsx"
import styles from "../hooks/pagination.module.scss"
import { useActionGuard } from "./useActionGuard.ts"
import { connect } from "react-redux"
import { ChevronLeft, ChevronRight } from "lucide-react"

const Pagination = ({ itemCount, take, isPublicProject, loading, ...props }) => {
  const { guard } = useActionGuard()
  const { currentPage, maxPageLimit, minPageLimit, response } = props
  const data = Array.isArray(props.response)
    ? props.response
    : (props.response?.entities || props.response || [])
  const effectiveTake = (take ?? response?.take) || 1
  const totalPage = Math.ceil((itemCount ?? response?.itemCount ?? 0) / effectiveTake)
  let pageIncrementEllipses = null
  let pageDecremenEllipses = null

  const pages = []
  if (totalPage > 1) {
    for (let i = 1; i <= totalPage; i++) {
      pages.push(i)
    }
  }

  const handlePrevClick = () => {
    if (currentPage > 1) {
      props.onPrevClick()
    }
  }

  const handleNextClick = () => {
    if (currentPage < totalPage) {
      props.onNextClick()
    }
  }

  const handlePageClick = (page) => {
    props.onPageChange(page)
  }

  const pageNumbers = pages.map((page, index) => {
    if (page <= maxPageLimit && page > minPageLimit) {
      return (
        <div
          key={page}
          id={page}
          onClick={() => handlePageClick(page)}
          className={`${styles.pageNumber} ${currentPage === page ? styles.active : ""}`}
          style={{ cursor: "pointer" }}
        >
          {page}
        </div>
      )
    } else {
      return null
    }
  })

  if (maxPageLimit < totalPage && props.onNextWindow) {
    pageIncrementEllipses = (
      <button
        type="button"
        onClick={props.onNextWindow}
        className={styles.ellipsis}
        title="Siguiente ventana"
        aria-label="Ir a la siguiente ventana de páginas"
      >
        ...
      </button>
    )
  }
  if (minPageLimit >= 1 && props.onPrevWindow) {
    pageDecremenEllipses = (
      <button
        type="button"
        onClick={props.onPrevWindow}
        className={styles.ellipsis}
        title="Ventana anterior"
        aria-label="Ir a la ventana anterior de páginas"
      >
        ...
      </button>
    )
  }

  const renderProjects = (projects, type, isQuotation) => {
    if (!projects || projects.length === 0) return null

    switch (true) {
      case isQuotation:
        return (
          <div className={styles.projectsGrid}>
            {projects.map((project) => (
              <QuotationsList item={project} key={project.id} quotation />
            ))}
          </div>
        )

      case type === "PRIVATE":
        return (
          <div className={styles.projectsGrid}>
            {projects.map((project) => (
              <AllProjectsItem item={project} key={project.id} />
            ))}
          </div>
        )

      case type === "PUBLIC":
        return (
          <div className={styles.projectsGrid}>
            {projects.map((project) => (
              <LicitacionesItem key={project.id} item={project} />
            ))}
          </div>
        )

      case type === "adjudicated":
        return (
          <div className={styles.projectsGrid}>
            {projects.map((project) => (
              <AdjudicatedItem key={project.id} item={project} />
            ))}
          </div>
        )

      default:
        return null
    }
  }

  const renderSkeletons = () => {
    return (
      <div className={styles.projectsGrid}>
        {Array.from({ length: 9 }).map((_, index) => (
          <div key={index} className={styles.skeleton}>
            <div className={styles.skeleton__header}></div>
            <div className={styles.skeleton__body}>
              <div className={styles.skeleton__line}></div>
              <div className={styles.skeleton__line}></div>
              <div className={styles.skeleton__line}></div>
            </div>
          </div>
        ))}
      </div>
    )
  }

  return (
    <div style={{ width: "100%" }}>
      {loading ? (
        renderSkeletons()
      ) : (
        <>
          {data && data.length > 0 && (
            <>
              {renderProjects(
                data.filter((p) => p.type === "PRIVATE"),
                "PRIVATE",
                props.isQuotation,
              )}
              {renderProjects(
                data.filter((p) => p.type === "PUBLIC"),
                "PUBLIC",
                props.isQuotation,
              )}
              {renderProjects(
                data.filter((p) => p.isQuotation),
                "QUOTATION",
                props.isQuotation,
              )}
              {renderProjects(
                data.filter((p) => !p.type),
                "adjudicated",
                props.isQuotation,
              )}
            </>
          )}
        </>
      )}

      {totalPage > 1 && (
        <div className={styles.sectionDivider}>
          <div className={styles.numbers}>
            <div className={styles.arrowContainer}>
              <button
                onClick={handlePrevClick}
                disabled={currentPage === pages[0]}
                className={styles.arrow}
                title="Atrás"
              >
                <ChevronLeft width={20} height={20} />
              </button>
            </div>
            <div className={styles.numbersContainer}>
              {pageDecremenEllipses}
              {pageNumbers}
              {pageIncrementEllipses}
            </div>
            <div className={styles.arrowContainer}>
              <button
                onClick={handleNextClick}
                disabled={currentPage === pages[pages.length - 1]}
                className={styles.arrow}
                title="Siguiente"
              >
                <ChevronRight width={20} height={20} />
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    take: state.dashboard.take,
    itemCount: state.dashboard.itemCount,
  }
}

export default connect(mapStateToProps)(Pagination)

